/* eslint-disable react/jsx-props-no-spreading */
/**
 * @fileoverview Componente Molecule para input de chat aislado en el Inbox.
 * Permite manejar el estado de formulario de manera independiente, evitando re-renders del padre y facilitando integración modular.
 * Implementa arquitectura optimizada con separación de capas, memoización y uso de TailwindCSS.
 */
import React, { memo, forwardRef, useMemo } from 'react';
import FormProviderMC from '../../../components/FormProviderMC';
import ChatInputMC from './ChatInputMC';
import useChatForm from '../../../hooks/inbox/forms/useChatForm';

/**
 * Input de chat completamente aislado que no causa re-renders del componente padre
 * Maneja su propio estado de formulario internamente
 */
const IsolatedChatInputMC = memo(forwardRef(({
  setSelectedFastAnswer,
  setSelectedProduct,
  handleKeyDown,
  maxChars
}, ref) => {
  // Formulario completamente independiente
  const {
    methods,
    placeholder
  } = useChatForm({ maxChars });

  // Memoizar las props para evitar re-renders innecesarios
  const chatInputProps = useMemo(() => ({
    maxChars,
    placeholder,
    setSelectedFastAnswer,
    setSelectedProduct,
    handleKeyDown
  }), [maxChars, placeholder, setSelectedFastAnswer, setSelectedProduct, handleKeyDown]);

  return (
    <div className="tw-min-w-0 tw-flex-1">
      <FormProviderMC methods={methods}>
        <ChatInputMC {...chatInputProps} ref={ref} />
      </FormProviderMC>
    </div>
  );
}), (prevProps, nextProps) => (
  prevProps.setSelectedFastAnswer === nextProps.setSelectedFastAnswer
  && prevProps.onFormReady === nextProps.onFormReady
  && prevProps.setSelectedProduct === nextProps.setSelectedProduct
  && prevProps.handleKeyDown === nextProps.handleKeyDown
));

IsolatedChatInputMC.displayName = 'IsolatedChatInputMC';

export default IsolatedChatInputMC;
